module.exports = __webpack_public_path__ + "img/21-eng.331563f7.png";